const getFileNameFromContentDisposition = (contentDisposition) => {
  if (!contentDisposition) return null

  const encodedName = contentDisposition.match(/filename\*\s*=\s*([^;]+)/i)?.[1]
  if (encodedName) {
    const value = encodedName.trim().replace(/^"|"$/g, '')
    const encodedValue = value.match(/^[^']*'[^']*'(.*)$/)?.[1] || value
    try {
      return decodeURIComponent(encodedValue)
    } catch {
      return encodedValue
    }
  }

  return contentDisposition.match(/filename\s*=\s*(?:"([^"]+)"|([^;]+))/i)?.[1]
    ?.trim() || contentDisposition.match(/filename\s*=\s*([^;]+)/i)?.[1]?.trim()
}

const sanitizeFileName = (fileName) =>
  Array.from(String(fileName || 'download'), (character) => {
    const characterCode = character.charCodeAt(0)
    return characterCode < 32 || /[\\/:*?"<>|]/.test(character) ? '_' : character
  })
    .join('')
    .trim() || 'download'

export const downloadBlob = (response, fallbackFileName = 'download') => {
  const blob = response?.data
  const contentDisposition = response?.headers?.['content-disposition']
  const fileName =
    getFileNameFromContentDisposition(contentDisposition) || fallbackFileName
  const safeFileName = sanitizeFileName(fileName)
  const objectUrl = URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.href = objectUrl
  link.download = safeFileName
  link.style.display = 'none'
  document.body.appendChild(link)

  try {
    link.click()
  } finally {
    link.remove()
    // Defer revocation until the browser has started the download.
    window.setTimeout(() => URL.revokeObjectURL(objectUrl), 0)
  }
}
